const privacyPolicy = {
  title: "Политика за Поверителност",
  sections: [
    {
      heading: "1. Въведение",
      paragraphs: [
        'Elite Dental Solutions ("ние," "нашият," или "нас") уважава вашата поверителност и се ангажира да защитава вашите лични данни.',
        "Тази политика за поверителност обяснява как събираме, използваме и защитаваме вашата лична информация, когато използвате нашия уебсайт и услуги.",
      ],
    },
    {
      heading: "2. Информация, Която Събираме",
      paragraphs: [
        "Събираме информация, която ни предоставяте директно, включително:",
      ],
      bullets: [
        "Име и контактна информация",
        "Медицинска и дентална история",
        "Заявки за час и предпочитания",
        "Комуникация с нас",
        "Информация за плащане",
      ],
    },
    {
      heading: "3. Как Използваме Вашата Информация",
      paragraphs: ["Използваме вашата информация за:"],
      bullets: [
        "Предоставяне на дентални услуги и обработка на часове",
        "Комуникация относно вашето лечение",
        "Изпращане на напомняния за час",
        "Обработка на плащания",
        "Подобряване на нашите услуги",
        "Спазване на законови задължения",
      ],
    },
    {
      heading: "4. Защита на Данните",
      paragraphs: [
        "Прилагаме подходящи мерки за сигурност, за да защитим вашата лична информация от неоторизиран достъп, разкриване, промяна или унищожаване. Вашата медицинска информация се обработва в съответствие с приложимите закони и разпоредби за поверителност в здравеопазването.",
      ],
    },
    {
      heading: "5. Вашите Права",
      paragraphs: ["Имате право да:"],
      bullets: [
        "Достъпвате вашата лична информация",
        "Коригирате неточна информация",
        "Поискате изтриване на вашата информация",
        "Възразите срещу обработката на вашата информация",
        "Получите копие на вашата информация",
      ],
    },
    {
      heading: "6. Бисквитки и Проследяване",
      paragraphs: [
        "Нашият уебсайт използва бисквитки и подобни технологии за проследяване, за да подобри вашето потребителско изживяване. Можете да контролирате настройките на бисквитките чрез предпочитанията на вашия браузър.",
      ],
    },
    {
      heading: "7. Контактна Информация",
      paragraphs: [
        "За въпроси относно тази политика за поверителност или нашите практики за поверителност, моля, свържете се с нас на:",
        "Email: info@elitedentalsolutions.com",
        "Телефон: +359 879 800 430",
      ],
    },
    {
      heading: "8. Актуализации на Тази Политика",
      paragraphs: [
        "Можем да актуализираме тази политика за поверителност периодично. Последната версия винаги ще бъде достъпна на нашия уебсайт.",
        "Последна актуализация:",
      ],
      lastUpdatedLocale: "bg-BG",
    },
  ],
};

export default privacyPolicy;

